export const getMagazines = ({ magazineReducer: { magazines = [] } = {} }) => magazines;
export const getMagazineFilter = ({ magazineReducer: { filter = {} } = {} }) => filter;
export const getMagazineCount = ({ magazineReducer: { count = 0 } = {} }) => count;
export const getCommonFilter = ({ magazineReducer: { common_filter = {} } = {} }) => common_filter;
